export default __webpack_public_path__ + "static/media/dtwzq_page.128e1412.jpg";